import { call, put, takeEvery } from 'redux-saga/effects';
import { getFeatureFlags } from 'utils/featureFlags';
import { FEATURE_FLAGS_LOAD } from './types';
import { loadFeatureFlagsSuccess, loadFeatureFlagsFailure } from './actions';

/**
 * Load feature flags from remote service.
 *
 * @param {Object} action `FEATURE_FLAGS_LOAD` action
 */
function* featureFlagLoadSaga(action) {
  try {
    const { userId, attributes } = action.payload;
    const flags = yield call(getFeatureFlags, userId, attributes);
    yield put(loadFeatureFlagsSuccess(flags));
  } catch (error) {
    yield put(loadFeatureFlagsFailure(error));
  }
}

export default function* saga() {
  yield takeEvery(FEATURE_FLAGS_LOAD, featureFlagLoadSaga);
}
